import React, { useContext } from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Grid } from 'semantic-ui-react'
import { FormFields } from '~/components/FormFields'
import { CoolFarmCropOptionsContext } from '../..'
import InfoPopup from '~/components/InfoPopup'

interface Props {
  index: number
}

const TreeSpecies: React.FC<Props> = ({ index }) => {
  const { t } = useTranslation()
  const { control } = useFormContext()
  const options = useContext(CoolFarmCropOptionsContext)

  const treeTypeOptions = options?.treeTypes?.map((type: any) => ({
    key: type.id || type.key,
    value: type.id || type.key,
    text: type.label
  })) || []

  const treeTypeSizeUnits = options?.treeTypeSizeUnits?.map((type: any) => ({
    key: type.id || type.key,
    value: type.id || type.key,
    text: type.label
  })) || []

  return (
    <Grid>
      <Grid.Row>
        <Grid.Column width={16}>
          <FormFields.Select
            control={control}
            name={`treeTypes[${index}].id`}
            rules={{
              required: true
            }}
            label={t('Choose tree species')}
            withoutAsterisk
            options={treeTypeOptions}
            placeholder={t('Select tree species')}
            noErrorMessage
          />
        </Grid.Column>
      </Grid.Row>

      <Grid.Row>
        <Grid.Column width={8}>
          <FormFields.Input
            control={control}
            name={`treeTypes[${index}].densityLastYear`}
            withoutAsterisk
            label={<label>
              <div style={{ display: 'flex', gap: 5, alignItems: 'center' }}>
                {t('Density last year')}
                <InfoPopup
                  content={t('Average density of trees per acre / hectare of your assessment area.')}
                  styleIcon={{ fontSize: '1.2em' }}
                />
              </div>
            </label>}
            suffix={t(' trees / hectar')}
            placeholder={t('Density')}
            typeInput='controled'
            noErrorMessage
          />
        </Grid.Column>

        <Grid.Column width={8}>
          <FormFields.Input
            control={control}
            suffix={t(' trees / hectar')}
            name={`treeTypes[${index}].treeBalance`}
            withoutAsterisk
            placeholder={t('Balance')}
            label={<label>
              <div style={{ display: 'flex', gap: 5, alignItems: 'center' }}>
                {t('Trees planted/lost')}
                <InfoPopup
                  content={t('Enter the net change in number of trees (positive for planted, negative for lost)')}
                  styleIcon={{ fontSize: '1.2em' }}
                />
              </div>
            </label>}
            typeInput='controled'
            noErrorMessage
          />
        </Grid.Column>
      </Grid.Row>

      <Grid.Row style={{ alignItems: 'end' }}>
        <Grid.Column width={8}>
          <FormFields.Input
            control={control}
            name={`treeTypes[${index}].sizeLastYear`}
            withoutAsterisk
            placeholder={t('Size')}
            typeInput='controled'
            noErrorMessage
            label={<label>
              <div style={{ display: 'flex', gap: 5, alignItems: 'center' }}>
                {t('Size last year')}
                <InfoPopup
                  content={t('diameter at 15cm from ground')}
                  styleIcon={{ fontSize: '1.2em' }}
                />
              </div>
            </label>}
          />
        </Grid.Column>
        <Grid.Column width={8}>
          <FormFields.Select
            control={control}
            rules={{
              required: true
            }}
            placeholder={t('Select size unit')}
            withoutAsterisk
            noErrorMessage
            options={treeTypeSizeUnits}
            name={`treeTypes[${index}].sizeUnit`}
          />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row style={{ alignItems: 'end' }}>
        <Grid.Column width={8}>
          <FormFields.Input
            control={control}
            label={<label>
              <div style={{ display: 'flex', gap: 5, alignItems: 'center' }}>
                {t('Size this year')}
                <InfoPopup
                  content={t('Enter the average size of trees this year')}
                  styleIcon={{ fontSize: '1.2em' }}
                />
              </div>
            </label>
            }
            name={`treeTypes[${index}].sizeThisYear`}
            withoutAsterisk
            placeholder={t('Size')}
            typeInput='controled'
            noErrorMessage
          />
        </Grid.Column>
        <Grid.Column width={8}>
          <FormFields.Select
            control={control}
            rules={{
              required: true
            }}
            placeholder={t('Select size unit')}
            withoutAsterisk
            noErrorMessage
            label={''}
            options={treeTypeSizeUnits}
            name={`treeTypes[${index}].sizeUnit`}
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  )
}

export default TreeSpecies
